import React from 'react'
import { TreasureHuntTileOverlay } from './TreasureHuntTileOverlay'
import { getSize } from '../utils'

export const TreasureHuntTile = ({ rows, cols, tile, colorTheme, isTilePreview = false, isModal }) => {
    const width = isTilePreview ? '' : `${100 / Math.max(rows, cols)}%`
    const size = getSize(cols)
    return (
        <div className="treasure-hunt-preview-tile-container" style={{ width: width, height: width }}>
            <TreasureHuntTileOverlay tile={tile} colorTheme={colorTheme} isModal={isModal} size={size} />
        </div>
    )
}
